<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn"></div>-->
    <div id="contentDiv">
      <div class="head_title">
        <div class="head_title_font">
          <router-link to="/class" style="color: black">班级管理</router-link>
          &gt;{{clazzName}}
        </div>
      </div>
      <div class="body_content">
        <!--未开课前-->
        <div v-if="publishStatus == 0" class="classDetailsMenu">
          <!--<span class="samll_title">班级信息 &gt;</span>-->

          <router-link v-for="(one, oneIndex) in menu_one" :key="oneIndex" :to="{
            name: one.routeName,
            params: {
              clazzId: clazzId,
              publishStatus: publishStatus,
              classStatus: classStatus
            }
          }">
            <button type="button" class="btn btn-default optionMenu"
                    :class="{click_optionMenu: one.url == current_classDetails_menu, printPreview_one: one.routeName == 'PrintPreview'}"
                    @click="current_classDetails_menu = one.url">
              {{one.name}}
            </button>
          </router-link>

          <button type="button" class="btn btn-default optionMenu printPreview_one" @click="printPreviewPage()">
            预览打印
          </button>

          <label v-if="publishStatus == 0" class="publicLabel">
            <img src="../assets/img/right/classDetails/nopublish.png"/>&nbsp;未发布
          </label>
          <label v-else class="publicLabel">
            <img src="../assets/img/right/classDetails/yespublish.png"/>&nbsp;已发布
          </label>

          <button v-if="publishStatus == 1" type="button" class="btn btn-default optionBtn" @click="publishClass('0')">取消发布</button>
          <button v-if="publishStatus == 0" type="button" class="btn btn-default optionBtn" @click="publishClass('1')">确定发布</button>
          <button v-if="publishStatus == 0" type="button" class="btn btn-default optionBtn" @click="returnClass()">返回</button>
        </div>
        <!--已发布 未开班-->
        <div v-if="publishStatus == 1 && classStatus == 0" class="classDetailsMenu">
          <!--<span class="samll_title">班级信息 &gt;</span>-->

          <router-link v-for="(one, oneIndex) in menu_three" :key="oneIndex" :to="{
            name: one.routeName,
            params: {
              clazzId: clazzId,
              publishStatus: publishStatus,
              classStatus: classStatus
            }
          }">
            <button type="button" class="btn btn-default optionMenu"
                    :class="{click_optionMenu: one.url == current_classDetails_menu, printPreview_one: one.routeName == 'PrintPreview'}"
                    @click="current_classDetails_menu = one.url">
              {{one.name}}
            </button>
          </router-link>

          <button type="button" class="btn btn-default optionMenu printPreview_one" @click="printPreviewPage()">
            预览打印
          </button>

          <label v-if="publishStatus == 0" class="publicLabel">
            <img src="../assets/img/right/classDetails/nopublish.png"/>&nbsp;未发布
          </label>
          <label v-else class="publicLabel">
            <img src="../assets/img/right/classDetails/yespublish.png"/>&nbsp;已发布
          </label>

          <button v-if="publishStatus == 1" type="button" class="btn btn-default optionBtn" @click="publishClass('0')">取消发布</button>
          <button v-if="publishStatus == 0" type="button" class="btn btn-default optionBtn" @click="publishClass('1')">确定发布</button>
          <button v-if="publishStatus == 0" type="button" class="btn btn-default optionBtn" @click="returnClass()">返回</button>
        </div>
        <!--开课中以后-->
        <div v-else-if="publishStatus == 1 && classStatus != 0" class="classDetailsMenu">
          <router-link v-for="(two, twoIndex) in menu_two" :key="twoIndex" :to="{
            name: two.routeName,
            params: {
              clazzId: clazzId,
              publishStatus: publishStatus,
              classStatus: classStatus
            }
          }" v-if="(classStatus == 1 && two.routeName != 'HomeworkScore' && (two.routeName != 'TeachingEvaluation' || userCode.indexOf(leaderUserCode)!=-1)) || (classStatus == -1 && (two.routeName != 'HomeworkManage'&&two.routeName != 'PrintPreview' && two.routeName != 'QrCode') && (two.routeName != 'TeachingEvaluation' || userCode.indexOf(leaderUserCode)!=-1))">
            <button type="button" class="btn btn-default optionMenu"
                    :class="{click_optionMenu: two.url == current_classDetails_menu, special_distance: two.routeName == 'ClassAlbum', printPreview_two: two.routeName == 'PrintPreview'}"
                    @click="current_classDetails_menu = two.url">
              {{two.name}}
            </button>
          </router-link>

          <button type="button" class="btn btn-default optionMenu printPreview_one" @click="printPreviewPage()">
            预览打印
          </button>

        </div>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
  import {getContentSize} from './mainView';
  import {schoolAxios} from "../main";

  export default {
    name: "classDetails",
    data() {
      return {
        clazzId: this.$store.state.clazzId,
        publishStatus: this.$store.state.publishStatus,
        classStatus: this.$store.state.classStatus,
        userCode: this.$store.state.userCode,
        leaderUserCode: this.$store.state.leaderUserCode,

        clazzName: '',

        current_classDetails_menu : '',
        menu_one : [
          {'routeName': 'OpenClassMessage','url':'/openClassMessage','name':'开班信息'},
          {'routeName': 'StudentList','url':'/studentList','name':'学员名单'},
          {'routeName': 'TrainingSchedule','url':'/trainingSchedule','name':'培训日程'},
          // {'routeName': 'HomeworkArrange','url':'/homeworkArrange','name':'作业安排'},
          {'routeName': 'HomeworkArrange','url':'/homeworkArrange','name':'作业管理'},
          {'routeName': 'ClassResources','url':'/classResources','name':'教学资源'},
          //{'routeName': 'PrintPreview','url':'/printPreview','name':'预览打印'}
        ],
        menu_two : [
          {'routeName': 'OpenClassMessage','url':'/openClassMessage','name':'开班信息'},
          {'routeName': 'StudentList','url':'/studentList','name':'学员信息'},
          {'routeName': 'HomeworkManage','url':'/homeworkManage','name':'作业管理'},
          //{'routeName': 'AttendanceSituation','url':'/attendanceSituation','name':'考勤情况'},
          {'routeName': 'TrainingSchedule','url':'/trainingSchedule','name':'培训日程'},
          {'routeName': 'TeachingEvaluation','url':'/teachingEvaluation','name':'教学评估'},
          // {'routeName': 'HomeworkScore','url':'/homeworkScore','name':'作业成绩'},
          {'routeName': 'HomeworkScore','url':'/homeworkScore','name':'作业管理'},
          //{'routeName': 'ClassAlbum','url':'/classAlbum','name':'班级相册'},
          {'routeName': 'ClassResources','url':'/classResources','name':'教学资源'},
          {'routeName': 'QrCode','url':'/qrCode','name':'班级二维码'},
          {'routeName': 'CourseStatistics','url':'/courseStatistics','name':'课时统计'}
          //{'routeName': 'PrintPreview','url':'/printPreview','name':'预览打印'}
        ],
        menu_three : [
          {'routeName': 'OpenClassMessage','url':'/openClassMessage','name':'开班信息'},
          {'routeName': 'StudentList','url':'/studentList','name':'学员名单'},
          {'routeName': 'TrainingSchedule','url':'/trainingSchedule','name':'培训日程'},
          // {'routeName': 'HomeworkArrange','url':'/homeworkArrange','name':'作业安排'},
          {'routeName': 'HomeworkArrange','url':'/homeworkArrange','name':'作业管理'},
          {'routeName': 'ClassResources','url':'/classResources','name':'教学资源'},
          {'routeName': 'QrCode','url':'/qrCode','name':'班级二维码'},
          //{'routeName': 'PrintPreview','url':'/printPreview','name':'预览打印'}
        ],
      }
    },
    filters: {

    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        this_.current_classDetails_menu = this_.$route.path;

        this_.initClassDetails();
      });
    },
    methods: {
      /**
       * 查询班级名称
       */
      initClassDetails(){
        let this_=this;
        if(this_.clazzId) {
          schoolAxios({
            method: 'get',
            url: 'clazz/load/' + this_.clazzId,
            params: {}
          }).then(function (response) {
            let data = response.data;
            if (data.success) {
              this_.clazzName = data.data.name;
            }
          });
        }
      },
      /**
       * 发布 and 取消发布
       * @param flag 发布标识
       */
      publishClass(flag){
        let this_ = this;
        this_.clazzId=this.$store.state.clazzId;
        (flag=='1'?"确定发布班级":"确定取消发布班级").showConfirm(function () {
          schoolAxios({
            method: 'put',
            url: 'clazz/editCheckStatus',
            data: {
              id: this_.clazzId,
              checkStatus: flag
            }
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              //路由跳转
              this_.$router.push({
                name: 'Class',
              });
            }
          })
        })
      },
      /**
       * 返回班级路由
       */
      returnClass(){
        let this_ = this;
        //路由跳转
        this_.$router.push({
          name: 'Class',
        });
      },

      printPreviewPage(){
        let this_ = this;
        /*let routeUrl = this.$router.resolve({
          path: "/printPreview",
        });
        window.open(routeUrl.href, '_blank');*/
        window.open(this_.$store.state.specialFlag + "/printPreview", '_blank');
      },
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  @import "../assets/css/classDetails.css";
</style>



// WEBPACK FOOTER //
// src/components/classDetails.vue